import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import PatientsPage from "./pages/PatientsPage";
import ResultsPage from "./pages/ResultsPage";
import ResultadoDetalle from "./pages/ResultadoDetalle";
import OrdersPage from "./pages/OrdersPage";
import OrderExamsPage from "./pages/OrderExamsPage";
import ParamsPage from "./pages/ParamsPage";
import ConfigPage from "./pages/ConfigPage";
import TarifasExamenesPage from "./pages/TarifasExamenesPage";
import LandingPage from "./pages/LandingPage";
import InvoicesPage from "./pages/InvoicesPage";
import CajaPage from "./pages/CajaPage";
import WorklistPage from "./pages/WorklistPage";
import IndicadoresPage from "./pages/IndicadoresPage";
import PrivateRoute from "./components/PrivateRoute";
import RoleRoute from "./components/RoleRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />
        <Route path="/patients" element={<PatientsPage />} />
        <Route
          path="/results"
          element={
            <PrivateRoute>
              <ResultsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <PrivateRoute>
              <OrdersPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/order-exams"
          element={
            <PrivateRoute>
              <OrderExamsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/params"
          element={
            <RoleRoute menuKey="/params">
              <ParamsPage />
            </RoleRoute>
          }
        />
        <Route
          path="/config"
          element={
            <RoleRoute menuKey="/config">
              <ConfigPage />
            </RoleRoute>
          }
        />
        <Route
          path="/tarifas-examenes"
          element={
            <RoleRoute menuKey="/tarifas-examenes">
              <TarifasExamenesPage />
            </RoleRoute>
          }
        />
        <Route
          path="/invoices"
          element={
            <PrivateRoute>
              <InvoicesPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/caja"
          element={
            <RoleRoute menuKey="/caja">
              <CajaPage />
            </RoleRoute>
          }
        />
        <Route
          path="/worklist"
          element={
            <PrivateRoute>
              <WorklistPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/resultado-detalle"
          element={
            <PrivateRoute>
              <ResultadoDetalle />
            </PrivateRoute>
          }
        />
        <Route
          path="/indicadores"
          element={
            <PrivateRoute>
              <IndicadoresPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
